<template>
  <div>
    <h5 class="text-inside-line"><span>{{ $t('now') }}</span></h5>
    <CurrentData :query="query"></CurrentData>
    <h5 class="text-inside-line"><span>{{ $t('recent') }}</span></h5>
    <SelectDataRange @queryChanged="queryChangedHandler"></SelectDataRange>
    <SummaryChart></SummaryChart>
    <BatteryOccupation v-if="has_battery"></BatteryOccupation>
    <WeekChart v-if="range=='week'"></WeekChart>
    <MonthChart v-if="range=='month'"></MonthChart>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xl-special-4">
        <Savings></Savings>
        <ProductionNotUsed></ProductionNotUsed>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xl-special-5">
        <ConsumptionDetails></ConsumptionDetails>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentData from './CurrentData.vue'
import SelectDataRange from './SelectDataRange.vue'
import Savings from './Savings.vue'
import ProductionNotUsed from './ProductionNotUsed.vue'
import ConsumptionDetails from './ConsumptionDetails.vue'
import SummaryChart from './SummaryChart.vue'
import WeekChart from './WeekChart.vue'
import MonthChart from './MonthChart.vue'
import BatteryOccupation from './BatteryOccupation.vue'

export default {
  name: 'Home',
  components: {
    CurrentData,
    SelectDataRange,
    Savings,
    ProductionNotUsed,
    ConsumptionDetails,
    SummaryChart,
    WeekChart,
    MonthChart,
    BatteryOccupation,
  },
  data(){
    return {
      query: {},
    }
  },
  methods: {
    queryChangedHandler: function(query){
      this.query = query
    }
  },
  computed: {
    range: function(){
      return this.$store.getters.selected_range
    },
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      return this.$store.getters.user_bess
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-inside-line {
  position:relative;
  margin-top: 20px;
  text-align: center;
}
.text-inside-line::before {
  content: "";
  display: block;
  border-top: solid 1px #8d8888;
  width: 100%;
  height: 1px;
  position: absolute;
  top: 50%;
  z-index: 1;
}
.text-inside-line > span {
  background: #f7f8fb;
  padding: 0 20px;
  position: relative;
  z-index: 5;
  text-align: center;
}
</style>
